import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "progressBar"]

  static values = {
    items: Array
  }

  connect() {
    console.log("gallery connected")

    this.index = 0

    this.audio = new Audio()
    this.audio.loop = true
    this.audio.preload = "auto"

    // IMPORTANT: bind correcto
    this.updateProgress = this.updateProgress.bind(this)

    // loader de buffer (NO se elimina)
    this.loader = document.querySelector(".audio-loader-bar")

    this.audio.addEventListener("timeupdate", this.updateProgress)

    this.audio.addEventListener("canplaythrough", () => {
      if (this.loader) {
        this.loader.style.width = "100%"
      }
    })

    this.loadCurrent()
  }

  select(event) {
    this.index = Number(event.currentTarget.dataset.index)
    this.loadCurrent()
    this.audio.play()
  }

  play() {
    this.audio.play()
  }

  pause() {
    this.audio.pause()
  }

  loadCurrent() {
    const item = this.itemsValue[this.index]

    this.imageTarget.src = item.src
    this.imageTarget.alt = item.alt

    this.audio.pause()
    this.audio.currentTime = 0

    // reset playback bar
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = "0%"
    }

    // reset buffer loader
    if (this.loader) {
      this.loader.style.width = "0%"
    }

    this.audio.src = item.track
    this.audio.load()
  }

  updateProgress() {
    if (!this.audio.duration) return

    const percent =
      (this.audio.currentTime / this.audio.duration) * 100

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percent}%`
    }
  }

  disconnect() {
    this.audio.pause()
    this.audio.removeEventListener("timeupdate", this.updateProgress)
  }
}